import {
  GET_TOUR_ONBOARDING_STATUS_REQUEST,
  GET_TOUR_ONBOARDING_STATUS_SUCCESS,
  GET_TOUR_ONBOARDING_STATUS_FAIL,
  TOUR_ONBOARDING_STATUS_RESET,
} from "../constants/guidedTourConstants";

const initialState = {
  fetched: false,
  loading: false,
  data: null,
  error: null,
};

export const tourOnboardingStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TOUR_ONBOARDING_STATUS_REQUEST:
      return { ...state, fetched: true, loading: true, error: null };
    case GET_TOUR_ONBOARDING_STATUS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case GET_TOUR_ONBOARDING_STATUS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case TOUR_ONBOARDING_STATUS_RESET:
      return initialState;
    default:
      return state;
  }
};
